export function optimizeImageUrl(url, width = 800, quality = 70) {
  if (!url) return url;
  if (url.includes("images.pexels.com")) {
    return `${url}${url.includes("?") ? "&" : "?"}auto=compress&cs=tinysrgb&w=${width}&q=${quality}`;
  }
  if (url.includes("images.unsplash.com")) {
    return `${url}${url.includes("?") ? "&" : "?"}auto=format&fit=crop&w=${width}&q=${quality}`;
  }
  return url;
}

// Requests a smaller image on small screens - avoids downloading a flat 1600px
// wide banner image on a 390px mobile viewport, which slows down page loads.
export function responsiveWidth(desktopWidth, mobileWidth = 800) {
  if (typeof window === "undefined") return desktopWidth;
  return window.innerWidth < 640 ? mobileWidth : desktopWidth;
}
